<template>
  <div class="page-loader">
    <div class="block"></div>
  </div>
</template>

<script>
export default {
  name: 'PageLoader',
};
</script>

<style lang="scss" scoped>
.page-loader {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-white);
  z-index: 999;
  .block {
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before {
      content: '';
      display: block;
      background-color: var(--color-blue);
      border-radius: 50%;
      animation-name: inline_loader;
      animation-duration: 0.8s;
      animation-iteration-count: infinite;
      animation-direction: normal;
      animation-timing-function: linear;
    }
  }
}
@keyframes inline_loader {
  from {
    width: 0;
    height: 0;
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  80% {
    opacity: 0.5;
  }
  to {
    width: 80px;
    height: 80px;
    opacity: 0;
  }
}
</style>
